export default __webpack_public_path__ + "static/media/BronzeActive.94509cc3.svg";